export const TRASFER_GPS_TABS = Object.freeze({
  DOWNLOAD: '1',
  HISTORY: '2',
  MY_TOURS: '3',
  FRIEND_TOURS: '4',
});
